module.exports = __webpack_public_path__ + "img/starr.5b7be406.png";